import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=503714f0"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./profile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PopupAttachmentButton: require('/vercel/path0/components/blocks/PopupAttachmentButton.vue').default,CustomDropdown: require('/vercel/path0/components/ui/CustomDropdown.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default,Decorator: require('/vercel/path0/components/ui/decorator.vue').default,BaseCard: require('/vercel/path0/components/ui/BaseCard.vue').default,FootNote: require('/vercel/path0/components/FootNote.vue').default})
